import { useEffect, useRef } from 'react';
import { occasions } from '../../../mocks/home';

export default function Occasions() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const cards = sectionRef.current?.querySelectorAll('.fade-up');
    cards?.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="ocasioes" ref={sectionRef} className="py-28" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14 fade-up">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-4"
            style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.15)' }}
          >
            Momentos que ficam para sempre
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            Para qual{' '}
            <em className="italic" style={{ color: 'var(--gold)' }}>
              ocasião
            </em>{' '}
            é a homenagem?
          </h2>
          <p
            className="text-base max-w-lg mx-auto"
            style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Cada momento especial merece uma trilha sonora única. Escolha a ocasião e deixe a magia acontecer.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {occasions.map((occasion, index) => (
            <a
              key={occasion.id}
              href={occasion.href}
              className="glass home-card fade-up group p-6 rounded-2xl cursor-pointer transition-all duration-300"
              style={{
                backdropFilter: 'blur(18px)',
                WebkitBackdropFilter: 'blur(18px)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04)',
                border: '1px solid rgba(255,145,77,0.10)',
                transitionDelay: `${index * 0.07}s`,
                textDecoration: 'none',
                display: 'block',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 4px 20px rgba(200,131,42,0.12), 0 1px 4px rgba(0,0,0,0.05)';
                (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(200,131,42,0.25)';
                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04)';
                (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,145,77,0.10)';
                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
              }}
            >
              <div
                className="w-11 h-11 flex items-center justify-center rounded-xl mb-4"
                style={{ background: 'var(--badge-bg)' }}
              >
                <i
                  className={`${occasion.icon} text-lg`}
                  style={{ color: 'var(--gold)' }}
                />
              </div>
              <h3
                className="font-semibold text-base mb-2"
                style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}
              >
                {occasion.title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
              >
                {occasion.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
